import { QueryClient } from "@tanstack/react-query";

// The admin SPA's single TanStack Query client. Admin data is read-mostly
// supervision data with no live Pusher surface here, so we keep a short stale
// window and refetch on window focus (an operator returning to the tab wants
// fresh counts) — but NEVER poll on an interval (doctrine 1.2). Mutations
// invalidate the affected queries explicitly.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
